export const state = () => ({
  isLoading: false,
});

export const getters = {
  isLoading: state => state.isLoading,
};

export const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  },
};

export const actions = {
  showLoading({ commit, state }) {
    if (!state.isLoading) commit('setLoading', true);
  },
  hideLoading({ commit, state }) {
    if (state.isLoading) commit('setLoading', false);
  },
};
